export const SUBMIT_COMPLETED = 'ManageProjectDatasets.submitCompleted';

interface SubmitCompleted {
  type: typeof SUBMIT_COMPLETED
}

export type ManagedProjectDatasetsActionTypes
  = SubmitCompleted
